// GDPR cookie-consent + GTM loader.
// GTM is NOT loaded by index.html. It's only loaded here, after the user
// explicitly accepts analytics cookies. The choice is stored in localStorage.

const GTM_ID = "GTM-KNGT23G8";
const STORAGE_KEY = "pyl-cookie-consent"; // "accepted" | "rejected"

export type ConsentValue = "accepted" | "rejected" | null;

export function getConsent(): ConsentValue {
  if (typeof window === "undefined") return null;
  const v = localStorage.getItem(STORAGE_KEY);
  return v === "accepted" || v === "rejected" ? v : null;
}

export function setConsent(value: "accepted" | "rejected") {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, value);
  if (value === "accepted") loadGTM();
}

let gtmLoaded = false;
export function loadGTM() {
  if (gtmLoaded || typeof window === "undefined") return;
  if (document.getElementById("gtm-script")) {
    gtmLoaded = true;
    return;
  }
  gtmLoaded = true;

  // Standard GTM snippet, injected dynamically
  (function (w: any, d: Document, s: string, l: string, i: string) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s) as HTMLScriptElement;
    const dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.id = "gtm-script";
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode!.insertBefore(j, f);
  })(window, document, "script", "dataLayer", GTM_ID);
}

// Auto-load GTM if the user already accepted in a previous session
export function initConsent() {
  if (getConsent() === "accepted") loadGTM();
}

// Allow user to revisit choice (e.g. footer "Cookie settings" link)
export function resetConsent() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event("pyl-consent-reset"));
}
